<template>
  <Dialog
    v-model:visible="visible"
    style="width: 80vw"
    :modal="true"
    :closable="false"
  >
    <template #header>
      <h1>
        Veja o que há de novo no sistema
        <svg
          width="100"
          height="18"
          viewBox="0 0 92 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.0047674 0.0605372C-0.0260889 0.0914138 0.0961187 0.602391 0.276416 1.19571C0.456714 1.78902 0.751974 2.79706 0.932877 3.43518C1.26141 4.59638 1.52641 5.50996 1.78294 6.36119C1.85857 6.61123 1.99893 7.11071 2.09573 7.47155C2.19193 7.83177 2.41821 8.62669 2.5973 9.23696C2.77638 9.84783 3.07164 10.8692 3.25254 11.5073C3.86544 13.6656 3.98705 14.0798 4.1135 14.4339L4.23934 14.7869L5.7634 14.8147L7.28746 14.8426V14.5835C7.28746 14.4406 7.35159 14.0422 7.43024 13.6977C7.50889 13.3532 7.64927 12.6855 7.74244 12.2138C8.07763 10.5156 8.21738 9.82846 8.39768 8.98511C8.49811 8.51288 8.65663 7.74095 8.74981 7.26932C9.51153 3.39763 9.40988 3.58047 9.75475 5.45305C9.85155 5.98038 10.0125 6.7977 10.1117 7.26932C10.2109 7.74095 10.3689 8.51288 10.4626 8.98511C10.7065 10.2159 10.9007 11.1592 11.0646 11.9111C11.1433 12.272 11.3127 13.079 11.441 13.7044L11.6739 14.842L13.178 14.8141L14.6821 14.7869L14.7559 14.5344C15.0221 13.6208 15.2883 12.6909 15.4196 12.2138C15.5037 11.9087 15.6586 11.3638 15.7639 11.003C16.0392 10.0616 16.4221 8.70782 16.7289 7.59808C16.9346 6.85341 17.2631 5.71824 17.4229 5.2012C17.4912 4.97901 17.6267 4.50194 17.7229 4.14171C17.8197 3.78088 17.9867 3.19058 18.0932 2.82975C18.2003 2.46892 18.3576 1.92404 18.4435 1.6189C18.5294 1.31377 18.6638 0.859697 18.7424 0.609656C18.8205 0.360221 18.8846 0.116236 18.884 0.0684078C18.884 0.0205793 18.2826 -0.001213 17.5475 0.0205823C15.5854 0.078703 15.6126 0.0490331 14.9489 2.88C14.6645 4.09206 14.457 4.93299 14.091 6.36119C13.6832 7.95285 13.3075 9.47852 13.247 9.79213C13.181 10.1318 13.1738 10.1203 13.0491 9.48942C12.9783 9.12859 12.8362 8.44749 12.7339 7.97586C12.5536 7.1434 12.3642 6.20621 12.0617 4.64603C11.7961 3.27474 11.6394 2.4895 11.4283 1.46755C11.3139 0.912372 11.208 0.36749 11.1935 0.256698C11.1681 0.0647779 11.0804 0.0532765 9.43832 0.0272432L7.70916 0L7.64502 0.431057C7.60993 0.668384 7.51857 1.15696 7.44294 1.51779C7.36671 1.87862 7.20699 2.65055 7.0878 3.23357C6.96922 3.81599 6.8107 4.5879 6.73568 4.94874C6.66065 5.30957 6.52331 5.99067 6.43074 6.4623C6.33818 6.93392 6.19841 7.57265 6.11915 7.88141C6.0405 8.19018 5.97637 8.54677 5.97637 8.67331C5.97637 9.0299 5.64058 10.0779 5.60185 9.84238C5.54982 9.52816 5.2812 8.40148 5.07307 7.6229C4.969 7.23422 4.80928 6.57612 4.71852 6.15959C4.62777 5.74366 4.49043 5.15337 4.41359 4.84763C4.33615 4.54249 4.19699 3.95221 4.10322 3.53629C4.01004 3.11976 3.84909 2.50948 3.74503 2.17952C3.64097 1.84957 3.55626 1.496 3.55626 1.39308C3.55626 1.29076 3.477 0.935985 3.3796 0.605423L3.20354 0.00484098H1.63168C0.767702 0.00423556 0.0356237 0.0296605 0.0047674 0.0605372ZM30.3069 5.62984C30.3474 11.626 30.3516 11.6792 30.8641 12.6788C31.9828 14.862 36.264 15.7822 38.799 14.3831C40.2595 13.5772 41.1598 11.5909 41.1659 9.16068C41.1689 8.18413 40.8652 6.42294 40.6589 6.21528C40.6068 6.16261 40.5639 6.05909 40.5639 5.98583C40.5639 5.72731 39.7368 4.54613 39.2485 4.10659C37.742 2.75104 35.2675 2.74257 33.8451 4.08843L33.3538 4.55279L33.2957 2.6572C33.2636 1.61406 33.2292 0.756773 33.2201 0.75193C33.2104 0.746481 33.1003 0.624192 32.9756 0.480101C32.6459 0.099289 32.2968 0.00423072 31.2247 0.00423072H30.2688L30.3069 5.62984ZM47.3704 0.147116C46.3981 0.57939 46.412 0.460721 46.412 8.14235V14.8371H47.9754H49.5382V11.6084V8.37968H51.7665C54.8231 8.37968 55.286 8.1254 55.286 6.44717V5.65527H52.4121H49.5382V4.19196V2.72864H53.3698H57.2021V1.36644V0.00423072L52.4375 0.00847009C48.6918 0.0114972 47.6082 0.0411672 47.3704 0.147116ZM22.6648 3.3704C20.0807 4.34089 18.9324 7.03987 19.5356 10.7245C19.7607 12.0964 20.9423 14.1312 21.5146 14.1312C21.5649 14.1312 21.606 14.1687 21.606 14.2148C21.606 14.5241 23.5288 15.0636 24.6227 15.0611C27.0742 15.0557 28.8076 13.9272 29.6619 11.7803C29.8906 11.2046 29.8912 11.2046 28.4379 11.2052C27.0071 11.2064 26.8231 11.2591 26.35 11.8052C25.1514 13.188 22.6267 12.1842 22.617 10.3219L22.6146 9.89325H26.3101H30.0062L29.9378 8.60672C29.7817 5.65709 28.6437 3.96674 26.3591 3.2923C25.4921 3.03621 23.4392 3.07919 22.6648 3.3704ZM60.2774 3.32256C58.9433 3.76997 58.1187 4.56611 57.769 5.74608C57.5524 6.47501 57.5276 6.4623 59.149 6.4623H60.5799L60.8468 6.1275C61.5577 5.23632 64.1677 5.53176 64.1574 6.50225C64.1508 7.14703 63.3255 7.46791 60.8824 7.77607C57.9444 8.14719 56.5208 10.6597 57.7599 13.2885C59.025 15.9723 65.1449 15.5782 66.6175 12.7181C67.1808 11.6241 67.3114 5.93376 66.796 4.94874C66.5739 4.52555 65.9235 3.839 65.7444 3.839C65.7009 3.839 65.5448 3.75968 65.3978 3.66342C64.5961 3.13791 61.4512 2.92843 60.2774 3.32256ZM77.3192 3.37463C76.5635 3.62467 76.0396 3.84566 75.9579 3.94858C75.93 3.9837 75.7618 4.08662 75.5846 4.17804C75.1919 4.37904 74.864 4.80343 74.4816 5.60441L74.193 6.20983L74.1603 10.5235L74.1277 14.8371H75.6977H77.2684V10.8383C77.2684 6.37209 77.2538 6.47199 78.0065 5.93437C78.4784 5.59776 79.7048 5.6026 80.2003 5.94345C80.9856 6.48289 80.9457 6.23648 80.9784 10.776L81.008 14.8371H82.5599H84.1112L84.1433 10.8262C84.1675 7.88323 84.2092 6.75775 84.3006 6.59852C84.9806 5.40947 86.9512 5.35861 87.7395 6.51012C87.9519 6.8201 87.9574 6.90971 87.9574 10.2323C87.9574 14.7487 88.0003 14.8371 90.2002 14.8371H91.0835L91.0829 11.0284C91.0829 6.205 90.9395 5.35376 89.9721 4.442C88.425 2.98474 84.7314 2.65055 83.0669 3.81781L82.6634 4.10054L82.2338 3.81054C81.1823 3.10219 78.7864 2.88969 77.3192 3.37463ZM72.1765 3.43034C70.2603 3.63618 68.7308 4.65934 67.9885 6.23224C67.4772 7.31534 67.3865 8.13327 67.3865 11.6841V14.8371H68.9402H70.4945L70.5302 11.4316C70.578 6.90244 70.7159 6.63303 73.0586 6.48894L73.9407 6.43445V4.88456V3.33407L73.3611 3.34981C73.0423 3.35828 72.5092 3.39462 72.1765 3.43034ZM25.8121 6.0488C26.3064 6.40781 26.6017 6.87823 26.687 7.44612L26.7511 7.87475H24.6832H22.6146V7.51695C22.6146 6.10813 24.6227 5.18667 25.8121 6.0488ZM36.6167 6.00097C38.1885 6.79832 38.6018 10.2668 37.2955 11.6968C35.9959 13.1189 33.9237 12.4342 33.5014 10.4442C32.845 7.35288 34.5342 4.94511 36.6167 6.00097ZM64.2603 9.65955C64.2603 10.4793 63.9717 11.4007 63.5821 11.8221C62.2934 13.2158 59.8001 12.5523 60.3264 10.9564C60.5588 10.2535 60.7633 10.1463 62.9498 9.5875C63.4211 9.46763 63.8749 9.32898 63.9578 9.28055C64.2222 9.12738 64.2603 9.17582 64.2603 9.65955Z"
            fill="#396DF4"
          />
        </svg>
      </h1>
    </template>
    <p>
      Listamos abaixo as novidades adicionadas! Leia e se atualize de maneira
      rápida e prática.
    </p>
    <Divider></Divider>
    <div v-for="(version, index) in versions" :key="index">
      <h2>
        Versão {{ version.name }}
        <span v-if="version.title"> - {{ version.title }}</span>
        <span v-if="version.date"> - {{ $formatDate(version.date) }}</span>
      </h2>
      <div
        class="description"
        v-if="version.description"
        v-html="marked(version.description)"
      ></div>
      <Divider></Divider>
      <br />
    </div>
    <template #footer>
      <div class="p-grid p-jc-between p-mt-2">
        <div class="p-col-fixed p-mt-2">
          <div class="p-field-checkbox">
            <Checkbox name="dontShow" v-model="dontShow" :binary="true" />
            <label for="dontShow"> Não exibir novamente </label>
          </div>
        </div>
        <div class="p-col-fixed">
          <AppButton label="Fechar" @click="close()" />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Divider from 'primevue/divider';
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import { UserApi, VersionApi } from '../../../services/api';
import { marked } from 'marked';

export default {
  name: 'WhatsNew',
  components: {
    Divider,
  },
  data() {
    return {
      visible: false,
      versions: [],
      dontShow: true,
    };
  },
  computed: {
    ...mapFields('app', ['user']),
  },
  async created() {
    const versionResponse = await VersionApi.fetch({
      afterVersion: this.user.lastSeenVersion || undefined,
      afterDate: this.user.createdAt,
    });
    this.versions = versionResponse.results.filter(
      (result) => result.description
    );
    if (this.versions.length) {
      this.visible = true;
    }
  },
  methods: {
    ...mapActions('app', ['setUser']),
    marked,
    async close() {
      this.visible = false;
      const lastVersion = this.versions?.[0]?.name;
      if (lastVersion && this.dontShow) {
        await UserApi.updateMe({
          lastSeenVersion: lastVersion,
        });
        this.user.lastSeenVersion = lastVersion;
        this.setUser(this.user);
      }
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.8rem;
}
h2 {
  font-size: 1.5rem;
}

.description >>> h2 {
  font-size: 1.3rem;
}

.description >>> img {
  max-width: 100%;
}
</style>